<template>
  <div class='hidden lg:block pb-28'>&nbsp;</div>
</template>

<script>
export default {
  name: 'BottomNavigationDummy',
}
</script>
